import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'

async function lazyPage(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) throw new Error(`Supervisor bulk hiring page "${exportName}" not found`)
  return { Component: Page }
}

export const supervisorBulkHiringRoutes: RouteObject[] = [
  {
    path: 'supervisor/bulk-hiring',
    lazy: () => lazyPage(() => import('./pages/supervisor-bulk-hiring-page'), 'SupervisorBulkHiringPage'),
  },
  {
    path: 'supervisor/bulk-hiring/:caseId',
    lazy: () =>
      lazyPage(() => import('./pages/supervisor-bulk-hiring-person-page'), 'SupervisorBulkHiringPersonPage'),
  },
]
